import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import type { Pageable, WrapperPageableResponse, WrapperResponse } from './service-common';
import type { ChargeDTO, CustomerDTO, SaleDTO } from '../core/models';

export interface ReconciliationLineDTO {
  id?: number;
  reference?: string;
  cardNumberMasked?: string;
  issuer?: string;
  cardBrand?: string;
  typeTransaction?: string;
  status?: string;
  transactionAt?: string;
  amount?: number;
  commission?: number;
  taxAmount?: number;
  totalCommission?: number;
  lineTotal?: number;
  customerAlias?: string;
  metadata?: Record<string, unknown>;
  providerLineHash?: string;
  charge?: ChargeDTO;
  sale?: SaleDTO;
  customer?: CustomerDTO;
}

export interface ReconciliationDTO {
  id?: number;
  paymentProvider?: string;
  externalReconciliationId?: string;
  providerCreatedAt?: string;
  reconciliationType?: string;
  scattered?: boolean;
  subTotal?: number;
  totalAmount?: number;
  businessDate?: string;
  firstFetchedAt?: string;
  lastRefreshedAt?: string;
  transferTrackCode?: string;
  transferClabe?: string;
  transferConcept?: string;
  transferUrlCep?: string;
  transferBank?: string;
  transferOperationAt?: string;
  transferBeneficiaryName?: string;
  lines?: ReconciliationLineDTO[];
}

export interface ReconciliationFilterSpec {
  [key: string]: string | number | boolean | string[] | undefined | null;
}

@Injectable({
  providedIn: 'root'
})
export class ReconciliationService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  search(
    spec: ReconciliationFilterSpec = {},
    pageable: Pageable = { page: 0, size: 20 }
  ): Observable<WrapperPageableResponse<ReconciliationDTO>> {
    let params = new HttpParams();
    Object.entries(spec).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      if (Array.isArray(value)) {
        if (value.length > 0) {
          value.forEach(v => (params = params.append(key, String(v))));
        }
      } else if (value !== '') {
        params = params.append(key, String(value));
      }
    });
    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));
    if (pageable.sort && pageable.sort.length > 0) {
      pageable.sort.forEach(sort => (params = params.append('sort', sort)));
    }
    return this.http.get<WrapperPageableResponse<ReconciliationDTO>>(`${this.apiUrl}/reconciliations`, {
      params
    });
  }

  getById(id: number): Observable<WrapperResponse<ReconciliationDTO>> {
    return this.http.get<WrapperResponse<ReconciliationDTO>>(`${this.apiUrl}/reconciliations/${id}`);
  }
}
